import { InfinityIcon } from "@xola/icons";
import { Dot } from "@xola/ui-kit";
import clsx from "clsx";
import React from "react";
import { OPEN_UNLIMITED, Permission, Timeslot } from "types";
import { IsGranted } from "../IsGranted";
import { NoTranslate } from "../NoTranslate";
import { BannerDataProps } from "./BannerDataProps";
import { hasWaitlists } from "@/models/Timeslot";

export interface BannerAvailabilityProps {
    timeslot: Timeslot;
    bannerData: BannerDataProps;
}

export const BannerAvailability = ({ timeslot, bannerData }: BannerAvailabilityProps) => {
    const open = timeslot?.capacity?.open ?? 0;

    return (
        <div className="flex items-center justify-end space-x-2">
            <span className="font-bold" data-testid="banner-available">
                <NoTranslate className={clsx("mr-1", open === 0 && "text-danger")} data-testid="banner-infinity-icon">
                    {Number(open) >= OPEN_UNLIMITED ? <InfinityIcon /> : open}
                </NoTranslate>
                Available
            </span>
            <Dot color="secondary" />
            <span className="font-bold" data-testid="banner-reserved">
                <var data-var="reservedCount">{bannerData.reserved}</var> Reserved
            </span>

            <IsGranted permissions={Permission.WAITLISTS_VIEW}>
                {hasWaitlists(timeslot) ? (
                    <>
                        <Dot color="secondary" />

                        <span data-testid="event-banner-waitlist-count">
                            <var data-var="waitlistCount">{timeslot.waitlistCount}</var> Waitlisted
                        </span>
                    </>
                ) : null}
            </IsGranted>
        </div>
    );
};
